import { Modal } from '../../../../core/components/templates/Modal';
import Player from '../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../core/constants/modal-videos';

interface IModalHowTo {
  isOpen: boolean;
  onClose: () => void;
}

export function ModalHowTo({ isOpen, onClose }: IModalHowTo) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      title='Como funciona o Simulador?'
    >
      <Player
        playerType='modalVideo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.SIMULADOR.token}
        initialTime={0}
      />
    </Modal>
  );
}
